import service from "../../services/gestionTiempos/changeGroup";

export default {
  namespaced: true,
  state: {
    service: new service(),
    date: null,
    group: [],
    new: {},
    groupAssigned: [],
    deleteItem: {},
    editItems: {},
  },
  mutations: {
    setGroup(state, data) {
      state.group = data;
    },
    setDate(state, data) {
      state.date = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setGroupAssigned(state, data) {
      state.groupAssigned = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setEditItems(state, data) {
      state.editItems = data;
    },
  },
  actions: {
    async getGroups({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getGroups(state.date);

        commit("setGroup", { item, name });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    async newGroup({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.new(state.new).then((data) => {
            let items = state.new;

            commit("setNew", items);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getGroupsAssigned({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getGroupsAssigned();
          commit("setGroupAssigned", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async delete({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.delete(state.deleteItem).then(() => {
            const deleteitem = state.deleteItem;

            commit("setDeleteItem", deleteitem);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async edit({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.edit(state.editItems).then(() => {
            const item = state.editItems;

            commit("setEditItems", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
